import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_VALUATION_RESOURCE } from "./use-vehicle-valuation-search.query";

const VEHICLE_RESOURCE = "vehicle" as const;
const VEHICLE_VALUATION_SYNC_V1_GEWA_OPERATION = "sync-v1-gewa" as const;
export const VEHICLE_VALUATION_SYNC_V1_GEWA_API_PATH =
  `/v1/${VEHICLE_VALUATION_RESOURCE}/{uuid}/${VEHICLE_VALUATION_SYNC_V1_GEWA_OPERATION}` as const;

export type VehicleValuationSyncV1GewaResponse =
  paths[typeof VEHICLE_VALUATION_SYNC_V1_GEWA_API_PATH]["post"]["responses"][201]["content"]["application/json"];
export type VehicleValuationSyncV1GewaBody =
  paths[typeof VEHICLE_VALUATION_SYNC_V1_GEWA_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export const useVehicleValuationSyncV1GewaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationSyncV1GewaResponse, Error, { uuid: string; branchUuid?: string }>({
    mutationFn: async ({ uuid, branchUuid }) => {
      const apiPath = VEHICLE_VALUATION_SYNC_V1_GEWA_API_PATH.replace("{uuid}", uuid);
      const body = { branchUuid } satisfies VehicleValuationSyncV1GewaBody;
      const response = await alphartisApiAxios.post<VehicleValuationSyncV1GewaResponse>(apiPath, body);

      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_VALUATION_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_RESOURCE],
        }),
      ]);
    },
  });
};
